export const PageNotFoundStaticData = {
  pageNotFoundText: 'Oops ! Page Not Found',
};

export const PageNotFoundHindiData = {
  pageNotFoundText: 'ऊप्स! पृष्ठ नहीं मिला',
};

export const PageNotFoundArabicData = {
  pageNotFoundText: 'عذراً! الصفحة غير موجودة',
};
